import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface CandidateInput { name: string; email: string }
export interface ParticipantsValue { candidate: CandidateInput }

export interface ParticipantsEditorProps {
    value: ParticipantsValue;
    onChange: (val: ParticipantsValue) => void;
    candidateEditable?: boolean;
    showCandidate?: boolean;
}

export function ParticipantsEditor({ value, onChange, candidateEditable = true, showCandidate = true }: ParticipantsEditorProps) {
    return (
        <div className="grid grid-cols-1 gap-4 w-full">
            {showCandidate && (
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-2">
                        <Label htmlFor="candidate-name">Candidate name</Label>
                        <Input
                            id="candidate-name"
                            value={value.candidate.name}
                            disabled={!candidateEditable}
                            onChange={(e) => !candidateEditable ? undefined : onChange({ ...value, candidate: { ...value.candidate, name: e.target.value } })}
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <Label htmlFor="candidate-email">Candidate email</Label>
                        <Input
                            id="candidate-email"
                            type="email"
                            value={value.candidate.email}
                            disabled={!candidateEditable}
                            onChange={(e) => !candidateEditable ? undefined : onChange({ ...value, candidate: { ...value.candidate, email: e.target.value } })}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
